export const LOAD_ALL_OFFERS_SUCCESS = 'PRODUCTS_LOAD_ALL_OFFERS_SUCCESS'
